import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircle } from '@fortawesome/free-regular-svg-icons';

import { SectionHeader_2 } from '../../../../../component/landingComponent';
const AiArtificialIntelligence = () => {
    return (
        <div className='row px-10 mb-20'>
            <div className='col-md-12 text-center'>
                <SectionHeader_2
                    title= {`Artificial Intelligence (AI)`}
                />
            </div>
            <div className='row mt-20 border px-10 br-20'>
                <div className='col-md-7 pe-15 m-auto'>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Conversational AI, Agentic AI
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Custom-built LLMs, SLMs
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Natural Language Processing (NLP)
                            </li>
                            <li className="d-flex flex-column text-gray-700 fs-3">
                                <div className="d-flex">
                                    <FontAwesomeIcon icon={faCircleCheck} className="me-2 mt-1" />
                                    Speech Technologies
                                </div>
                                <ul className="ps-5 mt-2 ml-10">
                                    <li className="d-flex text-gray-700 fs-3">
                                    <span className="svg-icon svg-icon-9 me-3 text-gray-800 mt-1"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="mh-50px"><circle fill="currentColor" cx="12" cy="12" r="8"></circle></svg></span>
                                    Speech-2-text
                                    </li>
                                    <li className="d-flex text-gray-700 fs-3">
                                    <span className="svg-icon svg-icon-9 me-3 text-gray-800 mt-1"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="mh-50px"><circle fill="currentColor" cx="12" cy="12" r="8"></circle></svg></span>
                                    Text-2-speech
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-5 text-end m-auto'>
                    <img src="/assets/img/developer-guide.jpg" alt="app image" className="radius-20 p-10 pe-0" style={{}} />
                </div>
            </div>
        </div>
    )
}

export {AiArtificialIntelligence}